import React, { useState } from 'react';
import MuiSnackbar from '@mui/material/Snackbar';
import { useSelector, useDispatch } from 'react-redux';
import {
  IconCheck,
  IconCross,
  IconInfoRoundFilled,
  IconWarningTriangleFilled,
} from '@maiia/design-system';
import { showSnackbar } from '../../../src/actions/snackbar';
import Alert from '../../atoms/Alert/Alert';
import { useTranslation } from '@/src/i18n';

const NotificationIcon = ({ severity }) => {
  switch (severity) {
    case 'error':
      return <IconCross />;
    case 'warning':
      return <IconWarningTriangleFilled />;
    case 'info':
      return <IconInfoRoundFilled />;
    default:
      return <IconCheck />;
  }
};

const Notification = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const notification = useSelector(
    state => state?.['@snackbar/queue']?.notifications?.[0],
  );

  React.useEffect(() => {
    if (notification) {
      setShow(false);
      if (notification.delay) {
        setTimeout(() => {
          dispatch(showSnackbar(notification));
          setShow(true);
        }, notification.delay);
      } else {
        dispatch(showSnackbar(notification));
        setShow(true);
      }
    }
  }, [notification]);

  if (!notification || !show) {
    return null;
  }
  const {
    severity = 'success',
    message: rawMessage,
    children: childrenProp,
    ...props
  } = notification;
  const message = t(rawMessage);

  const children = (
    <Alert
      data-key={notification.key}
      variant="filled"
      severity={severity}
      data-testid={severity}
      iconComponent={<NotificationIcon severity={severity} />}
    >
      {message}
    </Alert>
  );

  return (
    <MuiSnackbar open {...props}>
      {childrenProp
        ? React.cloneElement(childrenProp, {
            notificationKey: notification.key,
            message,
            severity,
          })
        : children}
    </MuiSnackbar>
  );
};

export default Notification;
